export default "<p>input-number-control works!</p>\n"